<template>
  <div>
    <div v-if="!isPhone">
      <div class="table-container">
        <vab-query-form style="margin: 0">
          <el-form ref="form" :model="queryForm" :inline="true" label-width="85px" @submit.native.prevent>
            <el-form-item label="用户编号">
              <el-input v-model="queryForm.user_code" placeholder="请输入用户编号" style="width: 140px" clearable
                @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="支付流水号">
              <el-input v-model="queryForm.pay_code" style="width: 220px" placeholder="请输入账号" clearable
                @keyup.enter.native="handleQuery" />
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input v-model="queryForm.order_code" style="width: 220px" placeholder="请输入订单编号" clearable
                @keyup.enter.native="handleQuery" />
            </el-form-item>

            <el-form-item label="支付状态">
              <el-select v-model="value" clearable placeholder="请选择" style="width: 140px" @keyup.enter.native="handleQuery">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="完成状态">
              <el-select v-model="queryForm.order_service_status" clearable placeholder="请选择" style="width: 140px">
                <el-option label="已完成" :value="1"></el-option>
                <el-option label="未完成" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付时间">
              <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                @change="handleDateChange"></el-date-picker>
            </el-form-item>
            <el-form-item label="扫描编号">
              <el-input v-model="order_code" style="width: 220px" placeholder="请输入订单编号" clearable
                @keyup.enter.native="getOrder(order_code)" />
            </el-form-item>
            <el-form-item label="">
              <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
                查询
              </el-button>
              <el-button type="primary" @click="exportForm()">批量导出</el-button>
            </el-form-item>
          </el-form>
        </vab-query-form>
        <el-table  ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
          :height="height" border @selection-change="setSelectRows">
          <el-table-column show-overflow-tooltip type="selection" width="55" align="center"></el-table-column>
          <!-- 用户名称 -->
          <el-table-column align="center" width="120" show-overflow-tooltip prop="nickname" label="用户昵称"></el-table-column>
          <!-- 完成状态 -->
          <el-table-column align="center" width="120" show-overflow-tooltip prop="order_service_status" label="完成状态">
            <template #default="{ row }">
              <el-tag v-if="row.order_service_status == 1" size="mini" type="success">
                已完成
              </el-tag>
              <el-tag v-else size="mini" type="danger">
                未完成
              </el-tag>
            </template>
          </el-table-column>
          <!-- 编码 -->
          <el-table-column align="center" width="120" show-overflow-tooltip prop="user_code" label="用户编号"></el-table-column>
          <!-- 库位号 -->
          <el-table-column align="center" width="120" show-overflow-tooltip prop="storage_location" label="库位号"></el-table-column>
          <!-- 支付账号 -->
          <el-table-column align="center" show-overflow-tooltip prop="pay_code" label="支付流水号" width="250"></el-table-column>
          <!-- 订单号 -->
          <el-table-column align="center" show-overflow-tooltip prop="order_code" label="订单编号"
            width="200"></el-table-column>
          <!-- icb账号 -->
          <el-table-column align="center" show-overflow-tooltip prop="icb_code" label="ICB流水号"
            width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="price" label="价格"></el-table-column>
          <el-table-column show-overflow-tooltip prop="status" label="支付状态" align="center">
            <template #default="{ row }">
              <el-tag v-if="row.status == 0" size="mini" type="danger">
                未支付
              </el-tag>
              <el-tag v-if="row.status == 1" size="mini" type="success">
                已支付
              </el-tag>
              <el-tag v-if="row.status == 2" size="mini" type="danger">
                已退款
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="goods_name" align="center" width="200"
            label="商品名称"></el-table-column>
          <el-table-column show-overflow-tooltip label="支付时间" prop="pay_time" width="160" align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120" align="center">
            <template #default="{ row }">
              <el-button type="text" native-type="submit" @click="seeInfo(row)">
                查看详情
              </el-button>
              <el-button type="text" native-type="submit" @click="tui_pop(row)">
                退款
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
      :page-sizes="[20, 50, 100, 200, 300, 400, 500]" :page-size="queryForm.limit" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>




        <!-- 申请退弹出层 -->

      </div>
    </div>
    <div  v-if="isPhone">
      <!-- 手机端筛选 -->
      <el-form ref="form" :model="queryForm" :inline="true" label-width="85px" @submit.native.prevent>
        <el-form-item label="用户编号">
          <el-input v-model="queryForm.user_code" placeholder="请输入用户编号"  clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="queryForm.order_code" style="width: 220px" placeholder="请输入订单编号" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>

        <el-form-item label="支付状态">
          <el-select v-model="value" clearable placeholder="请选择"  @keyup.enter.native="handleQuery">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="完成状态">
          <el-select v-model="queryForm.order_service_status" clearable placeholder="请选择">
            <el-option label="已完成" :value="1"></el-option>
            <el-option label="未完成" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="扫描编号">
          <el-input v-model="order_code" style="width: 220px" placeholder="请输入订单编号" clearable
            @keyup.enter.native="getOrder(order_code)" />
        </el-form-item>
        <el-form-item label="" style="display: flex; justify-content: flex-end;">
          <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <div v-for="(item , index) in list" :key="index" class="list_item">
        <div class="list_item_top" style="display: flex;align-items: center;">
          <span class="order_code" style="font-size: 14px; font-weight: 800;">订单编号：{{item.order_code}}</span>
          <span  class="order_code">{{item.add_time}}</span>
        </div>
        <div>
          <div class="list_itme_center">
           <div class="list_itme_span_th">
              <div class="list_itme_center_title">昵称:</div>
              <div class="list_itme_span">{{item.nickname}}({{item.user_code}})</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">价格:</div>
              <div class="list_itme_span">{{item.price}}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">商品名:</div>
              <div class="list_itme_span">{{item.goods_name}}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">库位号:</div>
              <div class="list_itme_span">{{item.storage_location?item.storage_location:'暂无库位'}}</div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">支付状态:</div>
              <div class="list_itme_span">
                <el-tag v-if="item.status == 0" size="mini" type="danger">
                  未支付
                </el-tag>
                <el-tag v-if="item.status == 1" size="mini" type="success">
                  已支付
                </el-tag>
                <el-tag v-if="item.status == 2" size="mini" type="danger">
                  已退款
                </el-tag>
              </div>
            </div>
            <div class="list_itme_span_th">
              <div class="list_itme_center_title">完成状态:</div>
              <div class="list_itme_span">
                <el-tag v-if="item.order_service_status == 1" size="mini" type="success">
                  已完成
                </el-tag>
                <el-tag v-else size="mini" type="danger">
                  未完成
                </el-tag>
              </div>
            </div>
            <div class="list_btn_box">
                <el-button size="mini" native-type="submit" @click="seeInfo(item)">
                  查看详情
                </el-button>
                <el-button type='danger' size="mini" native-type="submit" @click="tui_pop(item)">
                  退款
                </el-button>
            </div>
          </div>
        </div>
      </div>
      <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
        :page-sizes="[20, 50, 100, 200, 300, 400, 500]" :page-size="queryForm.limit" :total="total"
        @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
    </div>

    <el-dialog :visible.sync="dialogVisible" title="增值项详情" width="90vw">
      <el-table v-if="!isPhone" ref="tableSort" :data="item_form_list" height="500px" border>
        <el-table-column show-overflow-tooltip prop="name" label="服务名" align="center"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="add_time" label="添加时间" align="center"> </el-table-column>
        <el-table-column label="图片" align="center">
          <template #default="scope">
            <uploadFile v-if="scope.row.service_type==1 || scope.row.service_type==2" :limit="100" :img-list-string="scope.row.pic"
              @fileChange="skuListPicChange($event, scope.$index)" />
          </template>
        </el-table-column>
        <el-table-column label="视频" align="center">
          <template #default="scope">
            <uploadvideo v-if="scope.row.service_type==2" :img-list-string="scope.row.video"
              @fileChange="video_change($event, scope.$index)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="scope">
            <!-- <el-button size="mini" type="text" @click="handleEdit(row)">已完成</el-button> -->
            <div >
              <el-switch v-model="scope.row.tick" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </div>
          </template>
        </el-table-column>

      </el-table>
      <div  v-if="isPhone" style="height: 50vh; overflow-y: auto;">
        <div v-for="(item,index) in item_form_list" :key="index" class="pop_item">
          <div class="list_itme_span_th">
            <div class="list_itme_center_title">服务名:</div>
            <div class="list_itme_span">
              {{item.name}}
            </div>
          </div>
          <div v-if="item.service_type==1 || item.service_type==2" class="list_itme_span_th">
            <div class="list_itme_center_title">拍照:</div>
            <div class="list_itme_span">
              <uploadFile  :limit="100" :img-list-string="item.pic"
                @fileChange="skuListPicChange($event,index)" />
            </div>
          </div>
          <div v-if="item.service_type==2" class="list_itme_span_th">
            <div class="list_itme_center_title">视频:</div>
            <div class="list_itme_span">
                <uploadvideo  :img-list-string="item.video"
                  @fileChange="video_change($event, index)" />
            </div>
          </div>
          <div class="list_itme_span_th">
            <div class="list_itme_center_title">操作:</div>
            <div class="list_itme_span">
              <el-switch v-model="item.tick" active-color="#13ce66" inactive-color="#ff4949">
              </el-switch>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible_tui" title="退款" width="80vw">
      <el-form ref="form" :model="queryForm" label-width="85px" @submit.native.prevent>
        <el-form-item label="退款金额">
          <el-input v-model="tui_info.price" placeholder="请输入退款金额" style="width: 140px" disabled />
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input v-model="tui_info.application_refund_remark" placeholder="退款原因" style="width: 140px" disabled />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_tui=false">取消</el-button>
        <el-button type="primary" :loading="tui_loading" @click="tuiKuan">确认退款</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  import {
    Pay_service_list,
    oexcelOutPay,
    OrderService_detail,
    OrderService_file_add,
    OrderService_update,
    order_service_excel_out,
    orderRefundRefund
  } from '@/api/xgcApi'
  import {
    baseURL_print,
    getUploadUrl
  } from '@/config'
  import uploadFile from '@/components/uploadimg_small'
  import uploadvideo from '@/components/uploadvideo'
  export default {
    name: 'ManagePay',
    components: {
      uploadFile,
      uploadvideo
    },
    data() {
      return {
        isPhone:false,
        tui_loading:false,
        dialogVisible_tui: false, //退款弹出层
        tui_info:{},//退款详情
        order_code: null,
        chooseId: null,
        dialogVisible: false,
        item_form_list: [],
        height: '72vh',
        uploadFileUrl: baseURL_print + 'index/index/file',
        list: [],
        background: true,
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        selectRows: '',
        elementLoadingText: '正在加载...',
        queryForm: {
          'page': 1,
          'limit': 20,
          "pay_code": "", //支付账号
          "user_code": "", //用户唯一id
          "order_express_code": "", //订单转运单号
          "order_code": "", //订单号
          "status": "1", //0未支付 1已支付
          "start_time": "", //开始时间
          "end_time": "", //结束时间
          'order_service_status': "", //是否完成等
          'kor_type':0
        },
        value: '1',
        value1: '',
        options: [{
            value: '1',
            label: '已支付',
          },
          {
            value: '3',
            label: '退款中',
          },

        ],
        time: '',
      }
    },
    // computed: {
    //   height() {
    //     return this.$baseTableHeight()
    //   },
    // },
    created() {
      this.fetchData()
      this.isPhone = this.isMobile()

    },
    methods: {
      isMobile() {
        const userAgent = navigator.userAgent.toLowerCase();
        const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'windows phone'];
        var isModul = mobileKeywords.some(keyword => userAgent.includes(keyword))
        return isModul
      },
      tui_pop(row) {
       this.dialogVisible_tui = true
       this.tui_info = row
      },
      tuiKuan(){
        // 同意退款
        this.tui_loading = true
        var data = {
          "id": this.tui_info.order_id,
          "price": this.tui_info.price,
          "type": 7, //1正常包裹 2补拍 3代买 4代付 5代买商品 6包裹预约服务
          "refund_remarks": "" //退款理由
        }
        orderRefundRefund(data).then(res=>{
          this.$message({
            type: 'success',
            message: '退款成功!'
          });
         this.tui_loading = false
         this.fetchData()
         this.dialogVisible_tui = false
        }).catch(err=>{
          this.tui_loading = false
        })
      },
      getOrder(code) {
        OrderService_detail({
          order_code: code
        }).then(res => {
          this.dialogVisible = true
          this.item_form_list = res.data
          this.order_code = null
        })
      },
      video_change(e, index) {
        this.item_form_list[index].video = e[0]
        this.updateChagne(this.item_form_list[index])
        this.item_form_list[index].tick = true
      },
      updateChagne(item) {
        var data = {
          "order_service_id": item.id, //增值服务id
          "pic": item.pic, //图片
          "video": item.video //视频
        }
        OrderService_file_add(data).then(res => {

        })
      },
      skuListPicChange(e, index) {
        console.log(e ,index, '-------')
        this.item_form_list[index].pic = e.join(',')
        this.updateChagne(this.item_form_list[index])
        this.item_form_list[index].tick = true
      },
      save() {

        var arr = []
        this.item_form_list.forEach((item, index) => {
          if (item.tick == true) {
            arr.push(item.id)
          }
        })
        var data = {
          "order_id": this.chooseId, //订单id
          "order_service_id": arr.join(',') //增值服务id(逗号分隔)
        }
        OrderService_update(data).then(res => {
          this.$message({
            type: "success",
            message: '操作成功!'
          })
          this.dialogVisible = false
          this.fetchData()
        })
      },
      // 添加备注
      handleEdit1(index, row) {
        payUpdate(row).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
          this.fetchData()
        })
      },
      seeInfo(row) {
        this.chooseId = row.order_id
        OrderService_detail({
          order_id: row.order_id
        }).then(res => {
          this.dialogVisible = true
          this.item_form_list = res.data
        })
      },
      // 选择时间方法
      handleDateChange(value) {
        if (value != null) {
          this.queryForm.start_time = value[0]
          this.queryForm.end_time = value[1]
        } else {
          this.queryForm.start_time = ''
          this.queryForm.end_time = ''
        }
      },

      // 批量导出
      exportForm() {
        if (this.selectRows.length > 0) {
          this.$baseConfirm('确定导出已选', null, async () => {
            const ids = this.selectRows.map((item) => item.id).join()
            const {
              data
            } = await order_service_excel_out({
              id: ids,
            })
            const fileUrl = getUploadUrl + data
            window.open(fileUrl)
            this.$message({
              type: 'success',
              message: '导出成功',
            })
          })
        } else {
          this.$baseMessage('未选中任何行', 'error')
          return false
        }
      },

      // 批量导入
      // async handleChange(file, fileList) {
      //   if (file.response != undefined) {
      //     var strurl = file.response
      //     strurl = strurl.replace(/\\/g, '/')
      //     const {
      //       code,
      //       data,
      //       msg
      //     } = await uploadFileCw({
      //       file: strurl,
      //     })
      //     if (code == 200) {
      //       this.$message({
      //         type: 'success',
      //         message: '导入成功',
      //       })
      //       this.fetchData()
      //     } else {
      //       this.$baseMessage('失败')
      //       return false
      //     }
      //   }
      // },
      // 多选方法
      setSelectRows(val) {
        this.selectRows = val
      },

      // 分页
      handleSizeChange(val) {
        this.queryForm.limit = val
        this.fetchData()
      },
      // 分页
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      // 查询方法
      handleQuery() {
        this.queryForm.page = 1
        this.queryForm.status = this.value
        this.queryForm.type = this.value1
        this.fetchData()
      },
      // 获取支付列表数据
      async fetchData() {
        this.listLoading = true
        // const {
        //   data
        // } = await payList(this.queryForm)
        var data = {
          ...this.queryForm
        }
        Pay_service_list(data).then((res) => {
          const {
            data
          } = res
          this.list = data.list
          this.total = data.count
          this.listLoading = false
        })

      },
    },
  }
</script>

<style scoped >
  @import url(./value_add_serveie.css);
  :deep .right-panel {
    display: flex;
    align-items: center;
  }

  :deep .el-form-item--small.el-form-item {
    margin-bottom: 10px !important;
  }
</style>
